import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
	timerBox: {
		display: "flex",
		marginLeft: 10,
		marginRight: 10,
		alignItems: "center",
		gap: 6,
	},
	// Bolinha vermelha piscando enquanto grava; parada e cinza quando pausado.
	dot: {
		width: 10,
		height: 10,
		borderRadius: "50%",
		backgroundColor: "#e53935",
		animation: "$blink 1s ease-in-out infinite",
	},
	dotPaused: {
		backgroundColor: theme.palette.text.disabled,
		animation: "none",
	},
	pausedLabel: {
		fontSize: 12,
		color: theme.palette.text.secondary,
	},
	"@keyframes blink": {
		"0%": { opacity: 1 },
		"50%": { opacity: 0.25 },
		"100%": { opacity: 1 },
	},
}));

const RecordingTimer = ({ paused = false }) => {
	const classes = useStyles();
	const initialState = {
		minutes: 0,
		seconds: 0,
	};
	const [timer, setTimer] = useState(initialState);

	// Pausado o relógio para; ao continuar, segue de onde parou.
	useEffect(() => {
		if (paused) return undefined;
		const interval = setInterval(
			() =>
				setTimer(prevState => {
					if (prevState.seconds === 59) {
						return { ...prevState, minutes: prevState.minutes + 1, seconds: 0 };
					}
					return { ...prevState, seconds: prevState.seconds + 1 };
				}),
			1000
		);
		return () => {
			clearInterval(interval);
		};
	}, [paused]);

	const addZero = n => {
		return n < 10 ? "0" + n : n;
	};

	return (
		<div className={classes.timerBox}>
			<span className={`${classes.dot} ${paused ? classes.dotPaused : ""}`} />
			<span>{`${addZero(timer.minutes)}:${addZero(timer.seconds)}`}</span>
			{paused && (
				<span className={classes.pausedLabel}>
					{i18n.t("messagesInput.recordingPaused")}
				</span>
			)}
		</div>
	);
};

export default RecordingTimer;
